// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior: (to, from, savedPosition) => {
        if (to.hash) return { selector: to.hash }
        if (savedPosition) return savedPosition

        return { x: 0, y: 0 }
    },
    routes: [{
        path: '/',
        component: () =>
            import ('@/layouts/home/Index.vue'),
        children: [{
                path: '/',
                name: 'Home',
                component: () =>
                    import ('@/views/home/Index.vue'),
            },
            {
                path: '/about-us',
                name: 'About Us',
                component: () =>
                    import ('@/views/about/Index.vue'),
                meta: { src: require('@/assets/nanny-cover1.jpg') },
            },
            {
                path: '/services',
                name: 'Services',
                component: () =>
                    import ('@/views/services/Index.vue'),
                meta: { src: require('@/assets/services.jpg') },
            },
            {
                path: '/testimonial',
                name: 'Testimonials',
                component: () =>
                    import ('@/views/testimonial/Index.vue'),
                meta: { src: require('@/assets/testimonials.jpg') },
            },
            {
                path: '/promotion',
                name: 'Promotions',
                component: () =>
                    import ('@/views/promotion/Index.vue'),
                meta: { src: require('@/assets/about.jpg') },
            },
            {
                path: '/faq',
                name: 'FAQ',
                component: () =>
                    import ('@/views/faq/Index.vue'),
                meta: { src: require('@/assets/partner.jpg') },
            },
            {
                path: '/blog',
                name: 'Blog',
                component: () =>
                    import ('@/views/blog/Index.vue'),
                meta: { src: require('@/assets/partner.jpg') },
            },
            {
                path: '/privacy-policy',
                name: 'Privacy Policy',
                component: () =>
                    import ('@/views/privacy-policy/Index.vue'),
                meta: { src: require('@/assets/partner.jpg') },
            },
            {
                path: '/contact-us',
                name: 'Contact Us',
                component: () =>
                    import ('@/views/contact-us/Index.vue'),
                meta: { src: require('@/assets/contact-us.jpg') },
            },
            {
                path: '/our-service',
                name: 'Service',
                component: () =>
                    import ('@/views/our-service/service1.vue'),
                meta: { src: require('@/assets/contact.jpg') },
            },

            {
                path: '/confinement-nanny',
                name: 'Confinement Nanny',
                component: () =>
                    import ('@/views/our-service/service1.vue'),
                meta: { src: require('@/assets/confidencial-nanny.jpg') },
            },
            {
                path: '/domestic-helper',
                name: 'Domestic Helper',
                component: () =>
                    import ('@/views/our-service/service2.vue'),
                meta: { src: require('@/assets/domastic-worker.jpeg') },
            },
            {
                path: '/local-helper-caregiver',
                name: 'Local Helper & Caregiver',
                component: () =>
                    import ('@/views/our-service/service3.vue'),
                meta: { src: require('@/assets/local-caregivers.png') },
            },
            {
                path: '/confinement-herbs-package-meals',
                name: 'Confinement Herbs Package / Meals',
                component: () =>
                    import ('@/views/our-service/service4.vue'),
                meta: { src: require('@/assets/meals.jpg') },
            },

        ],
    }, ],
})

export default router